import dayjs from "dayjs";
import { FC } from "react";

import TextFile from "@icons/TextFile";
import Ellipse from "@src/assets/icons/Ellipse";
import { TypographyH6 } from "@src/components/shared-ui-components/CustomTypography";
import { Flex } from "@src/components/shared-ui-components/Flex";
import Colors from "@src/constants/Colors";

import { DEVICE, useWindowSizeChanged } from "@src/hooks/DeviceSize";
import { getPropertyName } from "@src/utils/dataTableHelper";
import {
  CHECK_TITLE,
  CHECK_TYPE_COLOR,
  getCheckIcon,
  getDescription,
} from "./helper";
import {
  ButtonText,
  ButtonWrapper,
  Description,
  HeaderTitle,
  NotificationCardWrapper,
  UnreadText,
} from "./style";

interface NotificationCardType {
  handleViewDetailsButton: (
    propertyShortName: string,
    checkNo: string,
    notificationId: string
  ) => void;
  notificationId: number;
  time: string;
  propertyShortName: string;
  rvcName: string;
  type: string;
  checkNo: string;
  unread: boolean;
}

const NotificationCard: FC<NotificationCardType> = ({
  handleViewDetailsButton,
  notificationId,
  time,
  propertyShortName,
  rvcName,
  type,
  checkNo,
  unread,
}) => {
  const propertyName = getPropertyName(propertyShortName, rvcName);

  const device = useWindowSizeChanged();
  const isMobile = device === DEVICE.MOBILE;
  return (
    <NotificationCardWrapper
      onClick={() =>
        handleViewDetailsButton(
          propertyShortName,
          checkNo,
          notificationId.toString()
        )
      }
    >
      <Flex justifyContent="space-between">
        <Flex gap="5" alignItems="center">
          {getCheckIcon(type)}
          <HeaderTitle color={CHECK_TYPE_COLOR[type]}>
            {CHECK_TITLE[type]}
          </HeaderTitle>
        </Flex>
        <ButtonWrapper>
          <TextFile color={Colors.primary} />
          <ButtonText>View Details</ButtonText>
        </ButtonWrapper>
      </Flex>
      <Description>{getDescription({ type, checkNo })}</Description>
      <Flex flexWrap="wrap" justifyContent="space-between">
        <Flex>
          <TypographyH6>{`${dayjs(time).format("h:mm A")}`}</TypographyH6>
          <Flex
            justifyContent="center"
            alignItems="center"
            style={{ padding: "0px 8px" }}
          >
            <Ellipse color={Colors.neutral_gray_500} />
          </Flex>
          {isMobile ? (
            <TypographyH6 ellipsis ellipsisWidth={160}>
              {propertyName}
            </TypographyH6>
          ) : (
            <TypographyH6>{propertyName}</TypographyH6>
          )}
        </Flex>
        {unread && (
          <Flex>
            <Flex
              justifyContent="center"
              alignItems="center"
              style={{ padding: "0px 8px" }}
            >
              <Ellipse width="8" height="8" color={Colors.success_500} />
            </Flex>
            <UnreadText>NEW</UnreadText>
          </Flex>
        )}
      </Flex>
    </NotificationCardWrapper>
  );
};

export default NotificationCard;
